////export default SignUp;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/Login.css';
import CryptoJS from 'crypto-js';

const SignUp = () => {
    const [companyName, setCompanyName] = useState('');
    const [contactPersonName, setContactPersonName] = useState('');
    const [vendorEmail, setVendorEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [address, setAddress] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [users, setUsers] = useState([]);
    const validateForm = () => {
        // Company Name
        if (!companyName.trim()) {
            setError('Company name is required.');
            return false;
        }

        // Contact Person Name - letters and spaces only
        const namePattern = /^[A-Za-z\s]+$/;
        if (!contactPersonName.trim()) {
            setError('Contact person name is required.');
            return false;
        }
        if (!namePattern.test(contactPersonName.trim())) {
            setError('Contact person name should only contain letters.');
            return false;
        }

        // Email - valid format
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!vendorEmail.trim()) {
            setError('Email is required.');
            return false;
        }
        if (!emailPattern.test(vendorEmail.trim())) {
            setError('Please enter a valid email address.');
            return false;
        }

        // Contact Number - exactly 10 digits
        const phonePattern = /^[0-9]{10}$/;
        if (!contactNumber.trim()) {
            setError('Contact number is required.');
            return false;
        }
        if (!phonePattern.test(contactNumber.trim())) {
            setError('Contact number must be exactly 10 digits.');
            return false;
        }

        // Address
        if (!address.trim()) {
            setError('Address is required.');
            return false;
        }

        // Password - required, no complexity restriction
        if (!password) {
            setError('Password is required.');
            return false;
        }

        // Confirm Password - must match
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return false;
        }

        return true;
    };

    const fetchUsers = async () => {
        
        try {
            const response = await axios.get('/api/userregistration');
            if (response.status === 200) {
                setUsers(response.data);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleSignUp = async (e) => {
        e.preventDefault();
        setError('');

        if (!validateForm()) {
            return;
        }

        /* const hashedPassword = CryptoJS.SHA1(password).toString(CryptoJS.enc.Base64).toUpperCase();*/
        const hashedPassword = CryptoJS.SHA1(password).toString(CryptoJS.enc.Hex).toUpperCase();

        const signUpData = {
            NameOfCompany: companyName,
            ContactPersonName: contactPersonName,
            EmailId: vendorEmail,
            ContactNumber: contactNumber,
            Address: address,
            Password: hashedPassword,
        };

        try {

            // const response = await axios.post('/api/userregistration', signUpData);

            const response = await axios.post('/api/userregistration', signUpData);
            console.log("response", response)
            if (response.status === 201) {
                setSuccessMessage('Your registration has been submitted and is waiting for approval.');
                setError('');
                fetchUsers();
                // Clear form fields
                setCompanyName('');
                setContactPersonName('');
                setVendorEmail('');
                setContactNumber('');
                setAddress('');
                setPassword('');
                setConfirmPassword('');
            } else {
                setError('Sign-up failed. Please try again.');
            }
        } catch (err) {
            console.log("FULL ERROR:", err.response);

            if (err.response) {
                setError(
                    err.response.data.details ||
                    err.response.data.message ||
                    "Something went wrong");
            } else {
                setError("Server not reachable");
            }
        
        }
        
    };

    return (
        <div className="login-page-wrapper">
            <Link to="/" className="glass-back-to-home">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Home
            </Link>

            <div className="login-glass-card" style={{ maxWidth: '600px' }}>
                <div className="glass-header">
                    <img
                        src={require("../assets/Mindteck Logo.png")}
                        alt="Mindteck Logo"
                        className="glass-logo-black"
                    />
                    <h2 className="glass-greeting">Create Your Account</h2>
                    <h3 className="glass-subheading">Vendor Management System</h3>
                </div>

                <Form onSubmit={handleSignUp} className="glass-form">

                    {/* Row 1: Company & Contact Person */}
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2" /><path d="M9 22v-4h6v4" /><path d="M8 6h.01" /><path d="M16 6h.01" /><path d="M12 6h.01" /><path d="M12 10h.01" /><path d="M12 14h.01" /><path d="M16 10h.01" /><path d="M16 14h.01" /><path d="M8 10h.01" /><path d="M8 14h.01" /></svg>
                            </span>
                            <Form.Control type="text" placeholder="Company Name" className="glass-input" value={companyName} onChange={(e) => setCompanyName(e.target.value)} required />
                        </div>

                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                            </span>
                            <Form.Control type="text" placeholder="Contact Person" className="glass-input" value={contactPersonName} onChange={(e) => setContactPersonName(e.target.value)} required />
                        </div>
                    </div>

                    {/* Row 2: Email & Phone */}
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                            </span>
                            <Form.Control type="email" placeholder="Email" className="glass-input" value={vendorEmail} onChange={(e) => setVendorEmail(e.target.value)} required />
                        </div>

                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                            </span>
                            <Form.Control type="text" placeholder="Contact Number" className="glass-input" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} required />
                        </div>
                    </div>

                    {/* Row 3: Address */}
                    <div className="glass-input-wrapper">
                        <span className="glass-input-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                        </span>
                        <Form.Control type="text" placeholder="Address" className="glass-input" value={address} onChange={(e) => setAddress(e.target.value)} required />
                    </div>

                    {/* Row 4: Passwords */}
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg>
                            </span>
                            <Form.Control type="password" placeholder="Password" className="glass-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </div>

                        <div className="glass-input-wrapper" style={{ flex: 1 }}>
                            <span className="glass-input-icon">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg>
                            </span>
                            <Form.Control type="password" placeholder="Confirm Password" className="glass-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                        </div>
                    </div>

                    {error && <Alert variant="danger" className="glass-error">{error}</Alert>}
                    {successMessage && <Alert variant="success" className="glass-error" style={{ background: '#f0fdf4', color: '#166534', borderColor: '#bbf7d0' }}>{successMessage}</Alert>}

                    <Button type="submit" className="glass-btn-liquid">
                        <span>Sign Up</span>
                        <svg className="glass-btn-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </Button>
                </Form>

                <div className="glass-signup-row">
                    Already have an account? <Link to="/login" className="glass-link-bold">Sign In</Link>
                </div>
            </div>
        </div>
    );
};

export default SignUp;

